const CACHE_ITINERARIOS_PREFIX = 'vexado_itinerarios_';
const CACHE_VIAGENS_PREFIX    = 'vexado_viagens_';
const CACHE_MAPA_PREFIX       = 'vexado_mapa_';
const CACHE_FORMAS_PREFIX     = 'vexado_formas_';
const CACHE_CIDADES_PREFIX    = 'vexado_cidades_';
const DB_NAME   = 'vexado-offline-db';
const STORE_NAME = 'fila-vendas';
const STORE_NAME_VENDA_URBANA = 'fila-vendas-urbanas';
const STORE_NAME_ENCOMENDA_AVULSA = 'fila-encomendas-avulsas';
const DB_VERSION = 3; // v3: adiciona fila-encomendas-avulsas

// ── helpers ──────────────────────────────────────────────────────────────────

function lsSet(chave, valor) {
  try {
    localStorage.setItem(chave, JSON.stringify(valor));
  } catch (e) {
    console.warn('offlineStorage: erro ao salvar', chave, e);
  }
}

function lsGet(chave) {
  try {
    const v = localStorage.getItem(chave);
    return v ? JSON.parse(v) : null;
  } catch (e) {
    console.warn('offlineStorage: erro ao carregar', chave, e);
    return null;
  }
}

// ── localStorage: cache de itinerários (painel de gestão) ───────────────────

export function salvarCacheItinerarios(empresaId, data, itinerarios) {
  lsSet(`${CACHE_ITINERARIOS_PREFIX}${empresaId}_${data}`, itinerarios);
}

export function carregarCacheItinerarios(empresaId, data) {
  return lsGet(`${CACHE_ITINERARIOS_PREFIX}${empresaId}_${data}`);
}

// ── localStorage: cache de viagens do terminal de venda ─────────────────────
// Chave: empresaId + origemId + destinoId + data (YYYY-MM-DD)

export function salvarCacheViagens(empresaId, origemId, destinoId, data, viagens) {
  lsSet(`${CACHE_VIAGENS_PREFIX}${empresaId}_${origemId}_${destinoId}_${data}`, viagens);
}

export function carregarCacheViagens(empresaId, origemId, destinoId, data) {
  const exato = lsGet(`${CACHE_VIAGENS_PREFIX}${empresaId}_${origemId}_${destinoId}_${data}`);
  if (exato && temViagens(exato)) return exato;
  return null;
}

function temViagens(dados) {
  return (dados.passagensIda && dados.passagensIda.length > 0) ||
         (dados.passagensRetorno && dados.passagensRetorno.length > 0);
}

// ── localStorage: cache de cidades para autocomplete offline ────────────────

export function salvarCacheCidades(empresaId, cidades) {
  lsSet(`${CACHE_CIDADES_PREFIX}${empresaId}`, cidades);
}

export function carregarCacheCidades(empresaId) {
  return lsGet(`${CACHE_CIDADES_PREFIX}${empresaId}`);
}

// ── localStorage: cache de mapa de poltronas ────────────────────────────────
// Chave: itinerarioId + origemId + destinoId + categoria
// Snapshot do momento do cache — poltronas vendidas offline podem estar desatualizadas,
// o servidor resolve no sync (409 → tenta poltrona alternativa).

export function salvarCacheMapa(itinerarioId, origemId, destinoId, categoria, mapa) {
  const cat = categoria || 'DEFAULT';
  lsSet(`${CACHE_MAPA_PREFIX}${itinerarioId}_${origemId}_${destinoId}_${cat}`, mapa);
}

export function carregarCacheMapa(itinerarioId, origemId, destinoId, categoria) {
  const cat = categoria || 'DEFAULT';
  return lsGet(`${CACHE_MAPA_PREFIX}${itinerarioId}_${origemId}_${destinoId}_${cat}`);
}

// ── localStorage: cache de formas de pagamento desativadas ──────────────────

export function salvarCacheFormasPagamento(empresaId, formas) {
  lsSet(`${CACHE_FORMAS_PREFIX}${empresaId}`, formas);
}

export function carregarCacheFormasPagamento(empresaId) {
  return lsGet(`${CACHE_FORMAS_PREFIX}${empresaId}`);
}


const CACHE_FORMAS_USUARIO_PREFIX = 'vexado_formas_usuario_';

export function salvarCacheFormasUsuario(empresaId, formas) {
  lsSet(`${CACHE_FORMAS_USUARIO_PREFIX}${empresaId}`, formas);
}

export function carregarCacheFormasUsuario(empresaId) {
  return lsGet(`${CACHE_FORMAS_USUARIO_PREFIX}${empresaId}`);
}

// ── IndexedDB: fila de vendas offline ───────────────────────────────────────

function abrirDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'idChaveOffline' });
      }
      if (!db.objectStoreNames.contains(STORE_NAME_VENDA_URBANA)) {
        db.createObjectStore(STORE_NAME_VENDA_URBANA, { keyPath: 'idChaveOffline' });
      }
      if (!db.objectStoreNames.contains(STORE_NAME_ENCOMENDA_AVULSA)) {
        db.createObjectStore(STORE_NAME_ENCOMENDA_AVULSA, { keyPath: 'idChaveOffline' });
      }
    };
    req.onsuccess = (e) => resolve(e.target.result);
    req.onerror  = (e) => reject(e.target.error);
  });
}

export async function salvarVendaOffline(venda) {
  const db = await abrirDB();
  return new Promise((resolve, reject) => {
    const tx  = db.transaction(STORE_NAME, 'readwrite');
    const req = tx.objectStore(STORE_NAME).put(venda);
    req.onsuccess = () => resolve();
    req.onerror   = (e) => reject(e.target.error);
  });
}

export async function buscarFilaVendas() {
  const db = await abrirDB();
  return new Promise((resolve, reject) => {
    const tx  = db.transaction(STORE_NAME, 'readonly');
    const req = tx.objectStore(STORE_NAME).getAll();
    req.onsuccess = (e) => resolve(e.target.result);
    req.onerror   = (e) => reject(e.target.error);
  });
}

export async function removerVendaDaFila(idChaveOffline) {
  const db = await abrirDB();
  return new Promise((resolve, reject) => {
    const tx  = db.transaction(STORE_NAME, 'readwrite');
    const req = tx.objectStore(STORE_NAME).delete(idChaveOffline);
    req.onsuccess = () => resolve();
    req.onerror   = (e) => reject(e.target.error);
  });
}

export async function buscarVendaOffline(idChaveOffline) {
  const db = await abrirDB();
  return new Promise((resolve, reject) => {
    const tx  = db.transaction(STORE_NAME, 'readonly');
    const req = tx.objectStore(STORE_NAME).get(idChaveOffline);
    req.onsuccess = (e) => resolve(e.target.result || null);
    req.onerror   = (e) => reject(e.target.error);
  });
}

// ── IndexedDB: fila de vendas urbanas offline ───────────────────────────────

export async function salvarVendaUrbanaOffline(venda) {
  const db = await abrirDB();
  return new Promise((resolve, reject) => {
    const tx  = db.transaction(STORE_NAME_VENDA_URBANA, 'readwrite');
    const req = tx.objectStore(STORE_NAME_VENDA_URBANA).put(venda);
    req.onsuccess = () => resolve();
    req.onerror   = (e) => reject(e.target.error);
  });
}

export async function buscarFilaVendasUrbanas() {
  const db = await abrirDB();
  return new Promise((resolve, reject) => {
    const tx  = db.transaction(STORE_NAME_VENDA_URBANA, 'readonly');
    const req = tx.objectStore(STORE_NAME_VENDA_URBANA).getAll();
    req.onsuccess = (e) => resolve(e.target.result);
    req.onerror   = (e) => reject(e.target.error);
  });
}

export async function removerVendaUrbanaDaFila(idChaveOffline) {
  const db = await abrirDB();
  return new Promise((resolve, reject) => {
    const tx  = db.transaction(STORE_NAME_VENDA_URBANA, 'readwrite');
    const req = tx.objectStore(STORE_NAME_VENDA_URBANA).delete(idChaveOffline);
    req.onsuccess = () => resolve();
    req.onerror   = (e) => reject(e.target.error);
  });
}

export function salvarMapeamentoVendaUrbanaSync(idChaveOffline, vendaUrbanaId) {
  lsSet(`vexado_sync_venda_urbana_${idChaveOffline}`, vendaUrbanaId);
}

export function buscarVendaUrbanaSincronizada(idChaveOffline) {
  return lsGet(`vexado_sync_venda_urbana_${idChaveOffline}`);
}

export function salvarMapeamentoPedidoSync(idChaveOffline, pedidoId) {
  lsSet(`vexado_sync_pedido_${idChaveOffline}`, pedidoId);
}

export function buscarPedidoSincronizado(idChaveOffline) {
  return lsGet(`vexado_sync_pedido_${idChaveOffline}`);
}

// ── localStorage: cache de itinerários abertos para venda urbana ────────────

const CACHE_ITINERARIOS_ABERTOS_VENDA_URBANA_PREFIX = 'vexado_itinerarios_abertos_venda_urbana_';

export function salvarCacheItinerariosAbertosVendaUrbana(empresaId, itinerarios) {
  lsSet(`${CACHE_ITINERARIOS_ABERTOS_VENDA_URBANA_PREFIX}${empresaId}`, itinerarios);
}

export function carregarCacheItinerariosAbertosVendaUrbana(empresaId) {
  return lsGet(`${CACHE_ITINERARIOS_ABERTOS_VENDA_URBANA_PREFIX}${empresaId}`);
}

// ── IndexedDB: fila de encomendas avulsas offline ───────────────────────────

export async function salvarEncomendaAvulsaOffline(encomenda) {
  const db = await abrirDB();
  return new Promise((resolve, reject) => {
    const tx  = db.transaction(STORE_NAME_ENCOMENDA_AVULSA, 'readwrite');
    const req = tx.objectStore(STORE_NAME_ENCOMENDA_AVULSA).put(encomenda);
    req.onsuccess = () => resolve();
    req.onerror   = (e) => reject(e.target.error);
  });
}

export async function buscarFilaEncomendasAvulsas() {
  const db = await abrirDB();
  return new Promise((resolve, reject) => {
    const tx  = db.transaction(STORE_NAME_ENCOMENDA_AVULSA, 'readonly');
    const req = tx.objectStore(STORE_NAME_ENCOMENDA_AVULSA).getAll();
    req.onsuccess = (e) => resolve(e.target.result);
    req.onerror   = (e) => reject(e.target.error);
  });
}

export async function removerEncomendaAvulsaDaFila(idChaveOffline) {
  const db = await abrirDB();
  return new Promise((resolve, reject) => {
    const tx  = db.transaction(STORE_NAME_ENCOMENDA_AVULSA, 'readwrite');
    const req = tx.objectStore(STORE_NAME_ENCOMENDA_AVULSA).delete(idChaveOffline);
    req.onsuccess = () => resolve();
    req.onerror   = (e) => reject(e.target.error);
  });
}

export function salvarMapeamentoEncomendaAvulsaSync(idChaveOffline, encomendaAvulsaId) {
  lsSet(`vexado_sync_encomenda_avulsa_${idChaveOffline}`, encomendaAvulsaId);
}

export function buscarEncomendaAvulsaSincronizada(idChaveOffline) {
  return lsGet(`vexado_sync_encomenda_avulsa_${idChaveOffline}`);
}

// ── localStorage: cache de itinerários abertos para encomenda avulsa ────────

const CACHE_ITINERARIOS_ABERTOS_ENCOMENDA_AVULSA_PREFIX = 'vexado_itinerarios_abertos_encomenda_avulsa_';

export function salvarCacheItinerariosAbertosEncomendaAvulsa(empresaId, itinerarios) {
  lsSet(`${CACHE_ITINERARIOS_ABERTOS_ENCOMENDA_AVULSA_PREFIX}${empresaId}`, itinerarios);
}

export function carregarCacheItinerariosAbertosEncomendaAvulsa(empresaId) {
  return lsGet(`${CACHE_ITINERARIOS_ABERTOS_ENCOMENDA_AVULSA_PREFIX}${empresaId}`);
}

// ── localStorage: cache do status do caixa aberto ───────────────────────────

const CACHE_CAIXA_PREFIX = 'vexado_caixa_aberto_';

export function salvarCacheCaixaAberto(empresaId, caixa) {
  lsSet(`${CACHE_CAIXA_PREFIX}${empresaId}`, caixa);
}

export function carregarCacheCaixaAberto(empresaId) {
  return lsGet(`${CACHE_CAIXA_PREFIX}${empresaId}`);
}
